// extracted by mini-css-extract-plugin
export default {"Container":"Dropzone_Container__-jjjv","Icon":"Dropzone_Icon__tsz7e","Animate":"Dropzone_Animate__XY-sf","animateIcon":"Dropzone_animateIcon__mDmR-"};